import React, { useState, useEffect } from "react";
import { Chip, useTheme, useMediaQuery } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";

const DivesLogged = ({ divesiteId, compact }) => {
  const [diveCount, setDiveCount] = useState(null);
  const { currentUser, userObjectId } = useAuth();

  // Mobile-friendly responsive design
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const fetchDiveCount = async () => {
      if (currentUser && divesiteId) {
        try {
          const token = await currentUser.getIdToken();
          const response = await fetch(
            `/api/dives/count/user/${userObjectId}/divesite/${divesiteId}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          if (data && data.count !== undefined) {
            setDiveCount(data.count);
          } else {
            setDiveCount(0);
          }
        } catch (error) {
          console.error("Error fetching dive count:", error);
          setDiveCount(null);
        }
      } else {
        setDiveCount(null);
      }
    };

    fetchDiveCount();
  }, [currentUser, divesiteId, userObjectId]);

  if (diveCount === null) {
    return null;
  }

  // Mobile-friendly styling and sizing
  const getChipProps = () => {
    if (compact || isMobile) {
      return {
        size: "small",
        label: `${diveCount}`,
        sx: {
          minWidth: "44px", // Minimum touch target size
          cursor: "default", // Explicitly set cursor to default
          height: "32px",
          fontSize: isMobile ? "0.75rem" : "0.8125rem",
          fontWeight: 500,
          // Better touch interaction
          "&:hover": {
            transform: "scale(1.02)",
            transition: "transform 0.1s ease-in-out",
          },
          // Improved contrast for mobile
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          // Better spacing on mobile
          margin: isMobile ? "2px" : "4px",
        },
      };
    }

    return {
      size: isTablet ? "medium" : "small",
      label: `Your Dives: ${diveCount}`,
      sx: {
        minWidth: "44px",
        cursor: "default", // Explicitly set cursor to default
        height: isTablet ? "36px" : "32px",
        fontSize: isTablet ? "0.875rem" : "0.8125rem",
        fontWeight: 500,
        "&:hover": {
          transform: "scale(1.02)",
          transition: "transform 0.1s ease-in-out",
        },
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        margin: "4px",
        
      },
    };
  };

  return <Chip {...getChipProps()} clickable={false} onClick={() => {}} />;
};

export default DivesLogged;
